import { IconButton } from "@circleco/compass/components/IconButton";
import { Menu } from "@circleco/compass/components/Menu";

import { t } from "@/i18n-js/instance";
import { useCommentsConfig } from "@/react/components/CommentsCompass/Provider/ConfigContext";
import type { Comment } from "@/react/types/Comment";

import { useActionMenuOptions } from "./useActionMenuOptions";

interface ActionMenuProps {
  comment: Comment;
}

export const ActionMenu = ({ comment }: ActionMenuProps) => {
  const options = useActionMenuOptions(comment);
  const { isEmbedded } = useCommentsConfig();

  if (isEmbedded || !options.length) return null;

  return (
    // h-5 matches the author row's label-sm line height, keeping the taller
    // icon button optically aligned with that line.
    <div className="flex h-5 items-center">
      <Menu
        align="end"
        side="bottom"
        options={options}
        trigger={
          <IconButton
            aria-label={t("comments.actions")}
            icon="dot-menu"
            size="sm"
            variant="ghost"
          />
        }
      />
    </div>
  );
};
